import { useTranslation } from 'react-i18next';
import { Card, BodyText, Box, MaterialSymbol, withStyles } from 'vopay';
import { Button } from '#shared/components/UI';
import Dialog from '#shared/components/Dialog/Dialog';
import styles from './BlockingDialog.module.scss';
import unBlockSubAccountIcon from './icons/unBlockSubAccount.svg';

const cn = withStyles(styles);

export type UnBlockDialogProps = {
  onConfirm: (val: boolean) => void;
  onCancel: () => void;
};

// The unblock-ALL-sub-accounts confirm, opened via useDialog().open() from the list root's unblockAllAccounts
// (ID-13193). Ported from client-dashboard's SubAccountsList/BlockingDialog; rewired to shared's Dialog + UI Button.
export default function UnBlockDialog({ onConfirm, onCancel }: UnBlockDialogProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.SubAccountList.UnblockDialog' });
  const { t: tButtons } = useTranslation('translations', { keyPrefix: 'Shared.Buttons' });

  return (
    <Card className={cn('dialogueCard')}>
      <div className={cn('icon')}>
        <img
          src={unBlockSubAccountIcon}
          alt={t('title', { defaultValue: 'Unblock Sub-Accounts' })}
          width="80"
          height="80"
        />
      </div>

      <div className={cn('title')}>
        <Dialog.Title level="3">{t('title', { defaultValue: 'Unblock Sub-Accounts' })}</Dialog.Title>
      </div>

      <BodyText className={cn('bodyText')}>
        <div className={cn('description')}>
          {t('description', { defaultValue: 'Unblocking all Sub-Accounts will enable:' })}
        </div>

        <ul className={cn('bulletList')}>
          <li>{t('resumeOutbound', { defaultValue: 'Outbound transactions from each sub-account will resume.' })}</li>

          <li>
            {t('depositInbound', {
              defaultValue:
                'Inbound transactions will deposit to the respective sub-accounts instead of the parent account.',
            })}
          </li>
        </ul>
      </BodyText>

      <Box className={cn('infoBox')}>
        <MaterialSymbol icon="lan" fillAmount={1} size="20px" color="#2F82FFBF" className={cn('infoIcon')} />

        <BodyText className={cn('bodyText')} size="rg">
          {t('impactMessage', { defaultValue: 'This will impact all sub-accounts.' })}
        </BodyText>
      </Box>

      <div className={cn('buttonContainer')}>
        <Button onClick={onCancel}>{tButtons('cancel', { defaultValue: 'Cancel' })}</Button>

        <Button colorScheme="primary" onClick={() => onConfirm(true)}>
          {t('confirmButton', { defaultValue: 'Confirm & Unblock' })}
        </Button>
      </div>
    </Card>
  );
}
